import styles from './AssessmentTrends.module.scss';

export const Glyph = (
  <svg viewBox="0 0 32 32" className={`chart-glyph ${styles.glyph}`}>
    <g>
      <path d="M 1 1 L 1 31 L 31 31" className={styles['chart-axis']} />
    </g>
    <g>
      <path
        className={styles.line1}
        d="M4,16C6.9,12.837209302325581,9.799999999999999,9.674418604651162,12.7,9C15.566666666666666,8.333333333333334,18.433333333333334,8.666666666666666,21.3,8C23.866666666666667,7.403100775193798,26.433333333333334,5.2015503875969,29,3"
      />
      <path
        className={styles.line2}
        d="M4,25C6.9,24.667641260025988,9.799999999999999,24.33528252005198,12.7,24C15.566666666666666,23.668571302017586,18.433333333333334,23.666666666666668,21.3,23C23.866666666666667,22.4031007751938,26.433333333333334,21.2015503875969,29,20"
      />
      <path
        className={styles.line3}
        d="M4,21C6.9,20.833333333333332,9.799999999999999,20.666666666666668,12.7,20C15.566666666666666,19.340996168582375,18.433333333333334,15.534061030993547,21.3,14C23.866666666666667,12.626480239691825,26.433333333333334,11.813240119845913,29,11"
      />
    </g>
  </svg>
);
